import React from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import {Tag} from "antd";
import useDocumentFirestore from '@web/hooks/useDocumentFirestore';

WorkflowActionLabel.propTypes = {
  action: PropTypes.object.isRequired,
  sequenceNumber: PropTypes.number,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

function WorkflowActionLabel(props) {
  // const [action] = useDocumentFirestore(props.path);
  const getColor = (type) => {
    switch (type) {
      case "data":
        return "green";
      case "reasoning":
        return "blue";
      case "agent":
        return "pink";
      default:
        return "default";
    }
  }

  if (!props.action) return <span className="font-lg">{props.placeholder}</span>;
  return <div className={props.className}>
    <Tag className="uppercase rounded" color={getColor(props.action.type)}>{props.sequenceNumber} {props.action.type}</Tag>
    <span className="font-lg">{props.action.method?.split(":").pop()}</span>
  </div>
}

export default WorkflowActionLabel;
